<template>
    <main-layout>
        <router-view></router-view>
    </main-layout>
</template>

<script>
    import MainLayout from './components/Layout.vue'

    export default {
        name: 'App',
        components: {MainLayout},
        created () {
            for (let m of window.messages) {
                this.$b_notify({
                    type: m.type,
                    content: m.message,
                    html: true,
                    duration: 0
                })
            }
        }
    }
</script>

<style scoped>

</style>
